<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      下沙站<br>
站点介绍<br>
9号线下沙站设于深圳市福田区滨河大道上，盛唐商务大厦和花好园高层小区附近，车站沿滨河大道呈东西向布置。下沙地铁站位于下沙村村口，下沙村是有着浓郁的民俗风情文化，优美的商业、旅游、居住环境，成为深圳市农村城市化的典范，是改革开放以来深圳农村变迁的一个缩影。下沙站的站厅吊顶以波浪形展现，车站站厅设有50平方米的艺术墙，凸显了车站的文艺气息，使下沙更有文化底蕴，车站吊顶高度4-5米之间，是九号线唯一吊顶最高的车站。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:06	23:39	9号线	3分50秒	5分55秒<br>
文锦	06:21	23:30	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:06	23:39	9号线	4分25秒	5分55秒<br>
文锦	06:20	23:30	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:08	00:39	9号线	4分钟	5分55秒<br>
文锦	06:19	00:30	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
B出入口:<br>
滨河大道南侧、东涌路、泰然广场、KK ONE（京基滨河时代广场）<br><br>
C出入口:<br>
滨河大道北侧（东）、泰然九路、深圳希玛林顺潮眼科医院、博今国际Bo space、海松大厦、盛唐大厦<br><br>
D出入口:<br>
滨河大道北侧（西）、泰然十一路、水松大厦、云松大厦<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 下沙①<br>
26、63、64、M103、E26、M347、M519、M520、NE26、高快巴士26、高峰专线433<br><br>
B出入口:<br>
公交站名： 下沙②<br>
34、229、236、E12、E13、M102、M105、M106、M133、高快巴士70<br><br>
C出入口:<br>
公交站名： 下沙①<br>
63、236、369、E06、E26、E37、M105、M106、M133、M194、高快巴士16、高快巴士26、高快巴士70、高快巴士14<br><br>
D出入口:<br>
公交站名： 下沙②<br>
34、229、337、E12、E13、M182、M463、M520、M559<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>